import * as React from 'react';
import { cn } from '../../lib/utils';

const Alert = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn('rounded-[2px] border bg-muted px-4 py-3 text-sm leading-6 text-muted-foreground', className)}
    {...props}
  />
));
Alert.displayName = 'Alert';

export { Alert };
